import CONSTANTES from "../constantes";


export const actionIniciarSesion = values => ({
    type: CONSTANTES.INICIAR_SESION,
    values,
})

export const actionEstablecerSesion = logged => ({
    type: CONSTANTES.ESTABLECER_SESION,
    logged,
})

export const actionCheckIfUser =() => ({
    type: CONSTANTES.CHECK_USER,     
})

export const actionLogoutUser =() => ({
    type: CONSTANTES.LOGOUT_USER,     
})

export const actionCerrarSesion=values =>({
    type: CONSTANTES.CERRAR_SESION,
    values,
})


export const actionGetUsuario=()=>({
    type:CONSTANTES.GET_USUARIO,
})

export const actionObtenerUsuario=(usuario)=>({
    type:CONSTANTES.OBTENER_USUARIO,
    usuario,
})



 //Get todos los usuarios del sistema//
export const actionGetUsuarios=(filter)=>({
    type:CONSTANTES.GET_USUARIOS,
    filter
})

//agregar todos los usuarios del sistema//
export const actionObtenerUsuarios=(usuarios)=>({
    type:CONSTANTES.OBTENER_USUARIOS,
    usuarios,
})
//ACTION PARA AGREGAR UN NUEVO USUARIO A NUESTRA BD/
export const actionRegistroUsuario= (values)=>({
    type:CONSTANTES.REGISTRO_USUARIO,
    values
});
//ACTION PARA AGREGAR AL USUARIO REGISTRADO AL STATE/
export const actionPutUsuarioRegistrado=(usuario)=>({
    type:CONSTANTES.ADD_USUARIO,
    usuario
})
//ACTION PARA EDITAR EL USUARIO
export const actionEditarUsuario=(idUsuario,values)=>({
    type:CONSTANTES.EDITAR_USUARIO,
    idUsuario,
    values
})
//ACTION PARACAMBIAR USUARIO EDITADO EN EL STATE
export const actionGetUsuarioEdit=(usuario)=>({
    type:CONSTANTES.EDIT_USUARIO,
    usuario
})

//ACTION PARA ELIMINAR EL USUARIO
export const actionEliminarUsuario=(idUsuario)=>({
    type:CONSTANTES.ELIMINAR_USUARIO,
    idUsuario
})

